// @ts-nocheck
import { Overlay } from '@angular/cdk/overlay';
import { NgClass } from '@angular/common';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
  ViewChild,
  forwardRef,
  inject,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ButtonComponent } from '@lbca-shared/button';
import { formatBytes } from '@lbca-shared/helpers/format-bytes';
import { dateTrim } from '@lbca-shared/helpers/formats';
import { IconComponent } from '@lbca-shared/icon';
import { UserInfo } from 'models/user.model';
import moment from 'moment';
import { map } from 'rxjs/operators';
import { v1 as uuidV1 } from 'uuid';
import { waitingTimer } from '../../../../../helpers/_old_helpers/animate';
import { SEND_SERVICE } from '../../../../../services/send.service';
import { TASK_SERVICE } from '../../../../../services/task.service';
import { USER_SERVICE, UserServiceInterface } from '../../../../../services/user.services';
import { WORKFLOW_INITIALIZER_SERVICE } from '../../../../../services/workflow-initializer.service';
import { LoadingComponent } from '../../../../_old_general-components/loading/loading.component';
import { BodyFeedbackComponent } from '../../../body-feedback/body-feedback.component';
import { ErrorOverlayClass } from '../../../error-overlay/error-overlay.directive';
import { FilesDownloadService } from '../../../fields/files-download/files-download.service';
import { InputBooleanComponent } from '../../../fields/input-boolean/input-boolean.component';
import { InputRadioComponent } from '../../../fields/input-radio/input-radio.component';
import { MessageFieldComponent } from '../../../fields/message-field/message-field.component';
import { SelectRoundedComponent } from '../../../fields/select-rounded/select-rounded.component';
import {
  PopupFeedbackDirective,
  PopupInterfaceCommunication,
} from '../../../popup-feedback/popup-feedback.directive';
import { TableFileComponent } from '../../../table-file/table-file.component';
import { DynamicFormService } from '../../dynamic-form.service';
import { FileUploadDirective } from './file-upload.directive';
import { fieldList } from './file-upload.fields';
import { FileUploadService } from './file-upload.service';

@Component({
  selector: 'lbca-sub-module-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrl: './file-upload.component.scss',
  imports: [
    LoadingComponent,
    MessageFieldComponent,
    FileUploadDirective,
    forwardRef(() => TableFileComponent),
    BodyFeedbackComponent,
    NgClass,
    SelectRoundedComponent,
    InputRadioComponent,
    InputBooleanComponent,
    IconComponent,
    ButtonComponent,
  ],
})
export class FileUploadComponent implements OnInit, OnChanges {
  readonly sendService = inject(SEND_SERVICE);
  readonly taskService = inject(TASK_SERVICE);
  readonly workflowInitializerService = inject(WORKFLOW_INITIALIZER_SERVICE);

  constructor(
    private fileUploadService: FileUploadService,
    private route: ActivatedRoute,
    public overlay: Overlay,
    private dynamicFormService: DynamicFormService,
    private elementRef: ElementRef,
    private cdr: ChangeDetectorRef,
    private filesDownloadService: FilesDownloadService,
    private router: Router
  ) {
    this.idFile = uuidV1();

    this.errorPopup = new ErrorOverlayClass(overlay);
    this.errorPopupType = new ErrorOverlayClass(overlay);
    this.errorPopup.setPosition(
      elementRef,
      [
        {
          originX: 'start',
          originY: 'top',
          overlayX: 'start',
          overlayY: 'bottom',
        },
      ],
      0,
      0,
      'bottom',
      'start'
    );
  }

  private popupFeedController = new PopupInterfaceCommunication();

  public configuration!: any;
  public field!: any;

  public isInitialized = false;
  public optionClientView = false;
  public optionDuplicateFile = false;
  public filesDuplicate: any[] = [];
  public hasError = false;
  public hasErrorRequerid = false;
  public subFormModuleInstance: any = null;
  public labelValue!: string;

  public formatBytes = formatBytes;

  @HostBinding('attr.lbcaPopupFeedback') popupFeedback = new PopupFeedbackDirective(
    this.overlay,
    this.popupFeedController
  );

  @ViewChild('templateRemove') templateRemove!: TemplateRef<any>;
  @ViewChild('templateRemoveError') templateRemoveError!: TemplateRef<any>;
  @ViewChild('templateMaxSizeError') templateMaxSizeError!: TemplateRef<any>;
  @ViewChild('templateInvalidExtensionError') templateInvalidExtensionError!: TemplateRef<any>;
  @ViewChild('templateBaixando') templateBaixando!: TemplateRef<any>;
  // @ViewChild('file', { static: false } ) file: ElementRef;
  @ViewChild('tableRef', { static: false }) tableRef!: ElementRef;
  @ViewChild('inputRefFiles', { static: false }) inputRefFiles!: ElementRef;
  @ViewChild('sizeFeedback', { static: true }) sizeFeedback!: ElementRef;
  @ViewChild('radioButtonValidado', { static: true })
  radioButtonValidado!: ElementRef;
  @ViewChild('checkboxSelectLine', { static: true })
  checkboxSelectLine!: ElementRef;
  @ViewChild('radioButtonVizualizacao', { static: true })
  radioButtonVizualizacao!: ElementRef;
  @ViewChild('radioButtonDuplication', { static: true })
  radioButtonDuplication!: ElementRef;
  @ViewChild('name', { static: true }) name!: ElementRef;
  @ViewChild('icon', { static: true }) icon!: ElementRef;
  @ViewChild('baixar', { static: true }) baixar!: ElementRef;
  @ViewChild('documentType', { static: true }) documentType!: ElementRef;
  @ViewChild('documentTypeAction', { static: true })
  documentTypeAction!: ElementRef;
  @ViewChild('actionsRender', { static: true }) actionsRender!: ElementRef;
  @ViewChild('countItens', { static: true }) countItens!: ElementRef;

  @Output('validateCallback') validateCallbackEmitter = new EventEmitter();
  isSaving!: boolean;

  @Input('initialized')
  set _initialized(value: boolean) {
    this.isInitialized = value;
  }

  @Input() idEntity;
  @Input('error') set err(error) {
    this.error = error;
  }
  @Input() set label(value: string) {
    this.labelValue = value;
  }

  public dataAttr;
  @Input('dataAttr') set data(data) {
    this.dataAttr = data;
  }
  public flowId;
  @Input('flowId') set flow(id) {
    this.flowId = id;
  }

  public fieldValue;
  @Input() set value(data) {
    this.fieldValue = data;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.configuration && changes['value']?.currentValue) {
      this.saveValueEmmiter.emit({
        context: this.fieldValue,
        entityKey: this.configuration.entityKey,
      });
    }
  }

  public condensed = false;
  @Input() set condensedView(data) {
    this.condensed = data;
  }

  @Input() editFilesContext: any;

  @Input('context') set contextSetter(val: string) {
    this.context = val;
  }

  public origin = '';
  @Input('origin') set setOrigin(val: string) {
    this.origin = val;
  }

  public cardInfo: any;
  @Input()
  set cardData(data: any) {
    this.cardInfo = data;
  }
  @Input() processId!: string;
  @Input('properties') set prop(value) {
    this.configuration = value;

    if (value.validator) {
      this.setClientViewOpt();
    }

    if (value.readonly) {
      this.readonly = value.readonly;
    }

    if (value.optionClientView) {
      this.optionClientView = value.optionClientView;
      this.setClientViewOpt();
    }

    if (value.optionDuplicateFile) {
      this.optionDuplicateFile = value.optionDuplicateFile;
      this.setDuplicateFileOpt();
    }

    if (this.configuration.selectItens) {
      this.setSelectFiles();
    }

    if (this.configuration?.rules?.remainingFileCount) {
      this.remainingFileCount = this.configuration.rules.remainingFileCount;
    }
    // if (value.fields) {
    //   this.field = value.fields.reduce(x => x).reduce( z => z );
    //   this.listfiletype = this.field.auxEntity.listOptions;
    // }
  }

  @Input() set disabled(value: boolean) {
    this.isDisabled = value;
    if (this.table.columns)
      this.table.columns
        .filter((disabled) => disabled.name === 'delete')
        .map((del) => (del.col = 1));
  }

  public readonly = false;
  public remainingFileCount = false;
  public count!: number;
  public idFile;

  @Output('setHasFile') setHasFileEmitter = new EventEmitter();
  @Output('cloudControl') cloudControlEmitter = new EventEmitter();
  @Output('errorApi') errorApiEmmiter = new EventEmitter();

  @Output('resetError') resetErrorEmmiter = new EventEmitter();

  @Output('saveValue') saveValueEmmiter = new EventEmitter();

  @Output('setValidator') setValidatorEmmiter = new EventEmitter();

  public filesInstance: any[] = [];

  public loadPage = false;
  public uploading = false;
  public retry = false;
  public prepareRemove = false;
  public actionSaveAll = false;

  public error = {};
  private errorList: any[] = [];

  private getUserData!: UserInfo;

  private taskId!: any;
  public paginationType: 'next' | 'prev' | 'choose' | 'none' = 'next';

  private initTable = false;
  public isDisabled = false;
  public pullSave = false;
  public canViewFiles = true; //!canViewFiles para save
  public canDuplicateFiles = true;

  public context!: string;
  public draft: any;

  public line;
  public lineremove;
  public updateBody = 0;

  public table: any = {};
  public tableRestore: any = [];
  public filesList: any = [];
  private selectedFiles: any = [];

  public errorRequeridPopup;

  public fileTypes = {
    doc: 'doc',
    docx: 'doc',
    odt: 'doc',
    jpg: 'jpg',
    jpeg: 'jpg',
    pdf: 'pdf',
    png: 'png',
    ppt: 'ppt',
    xls: 'xls',
    ods: 'xls',
    xlsx: 'xls',
    zip: 'zip',
  };

  public listfiletype;

  // private taskFormApis;
  private taskData;
  private errorPopup: ErrorOverlayClass;

  private errorPopupType: ErrorOverlayClass;
  readonly userService = inject<UserServiceInterface>(USER_SERVICE);

  public setSelectFiles = () => {
    this.table.columns = [
      {
        name: 'sendForBilling',
        label: 'Enviar para faturamento',
        css: 'min-w-[132px] ml-[20px] mr-[20px]',
        cssHeader: 'min-w-[132px] ml-[20px] mr-[20px]',
        type: 'data',
        col: 3,
        templateRef: this.checkboxSelectLine,
      },
      {
        name: 'fileName',
        label: 'Nome do arquivo',
        type: 'data',
        templateRef: this.name,
        order: true,
        orderDefault: true,
        col: 4,
      },
      {
        name: 'download',
        label: 'Baixar',
        type: 'data',
        templateRef: this.baixar,
        col: 2,
      },
      {
        name: 'size',
        label: 'Tamanho',
        type: 'data',
        cssHeader: 'text-left',
        templateRef: this.sizeFeedback,
        order: true,
        col: 2,
      },
      {
        name: 'uploadDate',
        label: 'Data de upload',
        type: 'data',
        order: true,
        col: 3,
      },
      {
        name: 'documentTypeName',
        label: 'Tipo de documento',
        css: 'min-w-[220px]',
        cssHeader: 'min-w-[220px]',
        type: 'data',
        templateRef: this.documentType,
        templateFooter: this.documentTypeAction,
        order: true,
        col: 6,
      },
      {
        name: 'vizualization',
        label: 'Vizualização do cliente',
        css: 'min-w-[132px] ml-[20px] mr-[20px]',
        cssHeader: 'min-w-[132px] ml-[20px] mr-[20px]',
        type: 'data',
        col: 3,
        templateRef: this.radioButtonVizualizacao,
      },
    ];
  };

  public setClientViewOpt = () => {
    this.table.columns = [
      {
        name: 'fileNameHash',
        label: 'Nome do arquivo',
        type: 'data',
        order: true,
        orderDefault: true,
        col: 4,
      },
      {
        name: 'fileName',
        label: 'Nome original',
        type: 'data',
        templateRef: this.name,
        order: true,
        orderDefault: true,
        col: 4,
      },
      {
        name: 'download',
        label: 'Baixar',
        type: 'data',
        templateRef: this.baixar,
        col: 2,
      },
      {
        name: 'size',
        label: 'Tamanho',
        type: 'data',
        cssHeader: 'text-left',
        templateRef: this.sizeFeedback,
        order: true,
        col: 2,
      },
      {
        name: 'uploadDate',
        label: 'Data de upload',
        type: 'data',
        order: true,
        col: 3,
      },
      {
        name: 'user',
        label: 'Usuário',
        type: 'data',
        order: true,
        col: 3,
      },
      {
        name: 'documentTypeName',
        label: 'Tipo de documento',
        css: 'min-w-[220px]',
        cssHeader: 'min-w-[220px]',
        type: 'data',
        templateRef: this.documentType,
        templateFooter: this.documentTypeAction,
        order: true,
        col: 6,
      },
      {
        name: 'vizualization',
        label: 'Vizualização do cliente',
        css: 'min-w-[132px] ml-[20px] mr-[20px]',
        cssHeader: 'min-w-[132px] ml-[20px] mr-[20px]',
        type: 'data',
        col: 3,
        templateRef: this.radioButtonVizualizacao,
      },
    ];
  };

  public setDuplicateFileOpt = () => {
    this.table.columns = [
      {
        name: 'fileNameHash',
        label: 'Nome do arquivo',
        type: 'data',
        order: true,
        orderDefault: true,
        col: 4,
      },
      {
        name: 'fileName',
        label: 'Nome original',
        type: 'data',
        templateRef: this.name,
        order: true,
        orderDefault: true,
        col: 4,
      },
      {
        name: 'download',
        label: 'Baixar',
        type: 'data',
        templateRef: this.baixar,
        col: 2,
      },
      {
        name: 'size',
        label: 'Tamanho',
        type: 'data',
        cssHeader: 'text-left',
        templateRef: this.sizeFeedback,
        order: true,
        col: 2,
      },
      {
        name: 'uploadDate',
        label: 'Data de upload',
        type: 'data',
        order: true,
        col: 3,
      },
      {
        name: 'user',
        label: 'Usuário',
        type: 'data',
        order: true,
        col: 3,
      },
      {
        name: 'documentTypeName',
        label: 'Tipo de documento',
        css: 'min-w-[220px]',
        cssHeader: 'min-w-[220px]',
        type: 'data',
        templateRef: this.documentType,
        templateFooter: this.documentTypeAction,
        order: true,
        col: 6,
      },
      {
        name: 'duplication',
        label: 'Anexar arquivo na tarefa',
        css: 'min-w-[132px] ml-[20px] mr-[20px]',
        cssHeader: 'min-w-[132px] ml-[20px] mr-[20px]',
        type: 'data',
        col: 3,
        templateRef: this.radioButtonDuplication,
      },
    ];
  };

  public setValidatorTable = () => {
    this.table.columns = [
      {
        name: 'fileName',
        label: '',
        type: 'data',
        templateRef: this.icon,
        orderDefault: true,
        col: 1,
      },
      {
        name: 'documentTypeName',
        label: 'Tipo de documento',
        css: 'min-w-[220px] ml-[20px] mr-[20px]',
        cssHeader: 'min-w-[220px] ml-[20px] mr-[20px] text-center',
        type: 'data',
        templateRef: this.documentType,
        order: true,
        col: 3,
      },
      {
        name: 'download',
        label: 'Baixar',
        type: 'data',
        templateRef: this.baixar,
        col: 2,
      },
      {
        name: 'uploadDate',
        label: 'Data do cadastro',
        type: 'data',
        col: 3,
      },
      {
        name: 'vizualization',
        label: 'Vizualização do cliente',
        css: 'min-w-[132px] ml-[20px] mr-[20px]',
        cssHeader: 'min-w-[132px] ml-[20px] mr-[20px]',
        type: 'data',
        col: 3,
        templateRef: this.radioButtonVizualizacao,
      },
      {
        name: 'Validado',
        label: 'Validação do documento',
        css: 'min-w-[184px]  ml-[20px] mr-[20px]',
        cssHeader: 'min-w-[184px]  ml-[20px] mr-[20px]',
        type: 'data',
        col: 5,
        templateRef: this.radioButtonValidado,
      },
    ];

    this.table.details = fieldList(this.context);
  };

  public validateCallbackFields = () => {
    let hasError = false;

    if (this.configuration.required && this.filesList.length === 0) {
      hasError = true;
      this.hasErrorRequerid = true;
    } else {
      this.hasErrorRequerid = false;
    }

    this.filesList.forEach((element) => {
      element.error = null;
      if (!element.documentType && typeof element.savedOk === 'undefined') {
        element.error = ['Selecione o tipo de arquivo antes de concluir a tarefa!'];
        hasError = true;
      }

      if (element.savedOk === false) {
        element.error = ['Confirme o tipo de arquivo antes de finalizar a tarefa!'];
        hasError = true;
      }
    });

    this.hasError = hasError;
    return this.hasError;
  };

  public checkIfHasCapability() {
    // ESSA CAPABILITY NAO EXISTE
    this.canViewFiles = this.userService.hasCapability('restrictedFiles');
  }

  stopPropagation($event) {
    $event.stopPropagation();
  }

  public showErrorRequerid() {
    if (this.hasErrorRequerid) {
      this.errorRequeridPopup = new ErrorOverlayClass(this.overlay);
      const component = document.getElementById('file-upload-button-anexo');
      this.errorRequeridPopup.setPosition(
        component,
        [
          {
            originX: 'start',
            originY: 'top',
            overlayX: 'start',
            overlayY: 'bottom',
          },
        ],
        0,
        0,
        'bottom',
        'start'
      );

      const errorFeedback = ['É obrigatório anexar arquivos!'];

      this.errorRequeridPopup.setErrors(errorFeedback);
      this.errorRequeridPopup.setFocus(true);
    } else {
      if (this.errorRequeridPopup) {
        this.errorRequeridPopup.setErrors([]);
        this.errorRequeridPopup.setFocus(false);
      }
    }
  }

  public removeErrorRequerid() {
    if (this.errorRequeridPopup) {
      this.errorRequeridPopup.setErrors([]);
      this.errorRequeridPopup.setFocus(false);
    }
  }

  public showError(event, file, id) {
    if (file.error) {
      this.errorPopupType = new ErrorOverlayClass(this.overlay);
      const component = document.getElementById(id);
      this.errorPopupType.setPosition(
        component,
        [
          {
            originX: 'end',
            originY: 'top',
            overlayX: 'end',
            overlayY: 'bottom',
          },
        ],
        0,
        0,
        'bottom',
        'end'
      );

      const errorFeedback: any[] = [];

      if (file.error) {
        if (file.error.length > 0) {
          file.error.forEach((element) => {
            if (element === 'upload_error')
              errorFeedback.push('Clique para reenviar os arquivos com erro!');
            else errorFeedback.push(element);
          });
        }
      }
      this.errorPopupType.setErrors(errorFeedback);
      this.errorPopupType.setFocus(true);
    } else {
      this.errorPopupType.setErrors([]);
      this.errorPopupType.setFocus(false);
    }
  }

  public removeError() {
    this.errorPopupType.setErrors([]);
    this.errorPopupType.setFocus(false);
  }

  async ngOnInit() {
    if (!this.origin)
      this.origin = this.dynamicFormService.formControlStructure.formMetadata.origin;
    const { flowId, processId } = this.dynamicFormService.formControlStructure.formMetadata;
    this.processId = processId;
    this.flowId = flowId ?? this.flowId;
    const { params } = this.route.snapshot;

    this.taskId = this.dynamicFormService?.taskId ?? params['id'];
    if (this.remainingFileCount) {
      this.getRemainingFileCount();
    }
    this.checkIfHasCapability();

    this.getUserData = this.userService.getUserInfo() as UserInfo;

    setTimeout(() => {
      if (this.configuration.maxFiles) {
        this.context = 'fileUnique_' + uuidV1();
      }
      this.context = this.configuration.context ?? (this.fieldValue || this.context);

      if (this.taskId !== 'createCase' && this.origin !== 'base' && !this.configuration.maxFiles) {
        this.fileUploadService.getTask(this.taskId).then(
          (resp) => {
            this.taskData = resp;
            this.context =
              this.taskData[0] && this.taskData[0].context
                ? this.taskData[0].context
                : this.context ?? this.taskData[0].bpmItemId;
            this.context = this.configuration.context || this.context;
            this.listFilesType().then((resp) => {
              this.listFiles();
            });
          },
          (err) => console.log(err)
        );
      } else {
        this.listFilesType().then((resp) => {
          this.listFiles();
        });
      }
    }, 500);

    this.table = {
      config: {
        highlight: (lane) => {
          return true;
        },
      },
      columns: [
        {
          name: 'content',
          type: 'action-delete',
          functionDelete: (element) => this.confirmDelete(element),
          col: 0,
        },
        {
          icon: 'icon-search',
          name: 'total',
          type: 'search',
          templateRef: this.countItens,
          col: 1,
        },
        {
          name: 'content',
          type: 'spacing',
          size: 5,
          col: 0,
        },
        {
          name: 'fileName',
          label: 'Nome original',
          type: 'data',
          templateRef: this.name,
          order: true,
          orderDefault: true,
          col: 4,
        },
        {
          name: 'fileNameHash',
          label: 'Nome do arquivo',
          type: 'data',
          order: true,
          enableCopy: true,
          orderDefault: true,
          col: 4,
        },

        {
          name: 'content',
          type: 'spacing',
          size: 20,
          col: 0,
        },
        {
          name: 'download',
          label: 'Baixar',
          type: 'data',
          templateRef: this.baixar,
          col: 2,
        },
        {
          name: 'content',
          type: 'spacing',
          size: 20,
          col: 0,
        },
        {
          name: 'size',
          label: 'Tamanho',
          type: 'data',
          cssHeader: 'text-left',
          templateRef: this.sizeFeedback,
          order: true,
          col: 2,
        },
        {
          name: 'content',
          type: 'spacing',
          size: 20,
          col: 0,
        },
        {
          name: 'origin',
          label: 'Registro de Origem',
          type: 'data',
          order: true,
          col: 2,
        },
        {
          name: 'content',
          type: 'spacing',
          size: 20,
          col: 0,
        },
        {
          name: 'uploadDate',
          label: 'Data de upload',
          type: 'data',
          order: true,
          col: 3,
        },
        {
          name: 'content',
          type: 'spacing',
          size: 20,
          col: 0,
        },
        {
          name: 'user',
          label: 'Usuário',
          type: 'data',
          order: true,
          col: 3,
        },
        {
          name: 'content',
          type: 'spacing',
          size: 20,
          col: 0,
        },
        {
          name: 'documentTypeName',
          label: 'Tipo de documento',
          css: 'min-w-[220px]',
          cssHeader: 'min-w-[220px]',
          type: 'data',
          templateRef: this.documentType,
          templateFooter: this.documentTypeAction,
          order: true,
          col: 6,
        },
        {
          name: 'content',
          type: 'spacing',
          size: 20,
          col: 0,
        },
        // {
        //   name: 'vizualization',
        //   label: 'Vizualização do cliente',
        //   css: 'min-w-[132px] ml-[20px] mr-[20px]',
        //   cssHeader: 'min-w-[132px] ml-[20px] mr-[20px]',
        //   type: 'data',
        //   col: 3,
        //   templateRef: this.radioButtonVizualizacao,
        // },
        // {
        //   name: 'content',
        //   type: 'spacing',
        //   size: 20,
        //   col: 0
        // },
        {
          name: 'delete',
          label: 'Excluir',
          type: 'data',
          cssHeader: 'text-left',
          templateRef: this.actionsRender,
          col: this.isDisabled || this.readonly ? 0 : 1,
        },
      ],
      body: [],
    };

    if (this.configuration.validator) {
      this.setValidatorTable();
      const initialize = setInterval(() => {
        if (
          this.dynamicFormService.formControlStructure.fieldControl[this.configuration.entityKey]
        ) {
          if (
            !this.dynamicFormService.formControlStructure.fieldControl[this.configuration.entityKey]
              ?.initialized
          ) {
            this.dynamicFormService.formControlStructure.fieldControl[
              this.configuration.entityKey
            ].value = false;
          }
          clearInterval(initialize);
        }
      }, 1000);
    }

    if (this.configuration.optionClientView) {
      this.setClientViewOpt();
    }

    if (this.configuration.optionDuplicateFile) {
      this.setDuplicateFileOpt();
    }

    if (this.configuration.selectItens) {
      this.setSelectFiles();
    }
    this.getDraft(this.taskId);
    this.validateCallbackEmitter.emit(this.validateCallbackFields);
  }

  private getDraft(taskId: string): void {
    this.taskService.getDraft({ taskId: taskId }).subscribe((resp: any) => {
      this.draft = resp;
    });
  }
  async listFilesType(): Promise<void> {
    const flowId = this.cardInfo.flowId ?? this.flowId;

    return new Promise((resolve) => {
      this.fileUploadService
        .listFilesType({ flowId, tableName: 'file-types' })
        .subscribe(async (resp) => {
          const listTypes: any[] = [];
          resp.forEach((item) => {
            // const isVisible = !(item.isVisible === false);
            listTypes.push({ value: item.id, label: item.label, isVisible: !item.deleted });
          });
          this.listfiletype = listTypes;
          resolve(resp);
        });
    });
  }

  async listFiles() {
    const FindUsers = [];
    const params: { [key: string]: string } = {
      processId: this.processId,
      flowId: this.cardInfo.flowId ?? this.flowId,
    };

    if (this.context) {
      if (this.context !== 'all') params['context'] = this.context;
    }

    if (this.origin !== 'base') params['taskId'] = this.taskId;

    if (!this.cardInfo.flowId && !this.flowId) console.error(`flowId em listFiles não encontrado`);

    this.fileUploadService
      .listFiles(params, this.configuration?.entityUrl)
      .subscribe(async (resp) => {
        if (resp?.length > 0) {
          this.setHasFileEmitter.emit(true);

          resp.forEach(async (file) => {
            const unixValue = file.updatedAt || file.createdAt;
            const lastModified = moment.unix(unixValue).format(moment.defaultFormat);

            const uploadDate =
              file.createdAt && file.createdAt > 0
                ? moment.unix(file.createdAt).format('DD/MM/YYYY')
                : null;
            (FindUsers as any).push(file.uploadBy);

            const fileCurrent = {
              origin: file.origin || null,
              bucket: file.bucket || null,
              context: file.context,
              key: file.key,
              id: file.id,
              icon: this.getIcon(file.fileType),
              index: this.filesList.length + 1,
              etag: file.ETag,
              fileName: file.fileName,
              fileNameHash: file.key.split(`/`).slice(-1)[0],
              fileType: file.fileType,
              fileId: file.fileId,
              documentType: file.documentType,
              documentTypeName: this.filterDocumentType(file.documentType),
              lastModified: lastModified,
              download: null,
              progress: null,
              size: file.length,
              moduleOrigin: file.moduleOrigin,
              uploadDate: uploadDate ? uploadDate : `-`,
              user: file.uploadBy,
              delete: false,
              confirmDelete: false,
              motionCompleteDataSend: false,
              editLabel: true,
              completeLoad: true,
              error: null,
              typeNotSaved: false,
              savedOk: true,
              validated: file.validated,
              clientView: file.clientView || false,
              duplicateFile: file.duplicateFile || false,
              sendForBilling: file.sendForBilling || false,
              justify: file.justify,
              observation: file.observation,
              opened: String(file.validated) === 'false' ? true : false,
              notExpandable: String(file.validated) === 'false' ? false : true,
            };

            this.filesList.push(fileCurrent);
            this.table.body = this.filesList;
            this.filesInstance.push({
              id: fileCurrent.id,
              value: fileCurrent.documentType,
              status: fileCurrent.documentType ? 'valid' : null,
            } as any);
          });

          this.filesList = [
            ...(await this.userService.returnUserListById(FindUsers, this.filesList)),
          ];

          this.updateBody = this.filesList.length;
          this.tableRestore = Object.assign(this.table.body);
        }

        this.initTable = true;

        this.loadPage = true;
      });
  }

  filterDocumentType(value) {
    const listaTipos = value
      ? this.listfiletype.find((labelType) => value === labelType.value)
      : null;
    return listaTipos ? listaTipos.label : `Qual o tipo de documento?`;
  }

  uploadTreatment($event) {
    this.startUpload($event.target.files);
    this.hasErrorRequerid = false;
    if (this.errorRequeridPopup) {
      this.errorRequeridPopup.setErrors([]);
      this.errorRequeridPopup.setFocus(false);
    }
    this.resetErrorEmmiter.emit();
    this.inputRefFiles.nativeElement.value = '';
  }

  onFileDrop($event) {
    this.startUpload($event);
    this.hasErrorRequerid = false;
  }

  checkFilesNotSaved() {
    const totalNotSaved = this.filesList.filter(
      (filterByNotSaved) => filterByNotSaved.typeNotSaved === true
    );
    if (totalNotSaved.length === 0) this.actionSaveAll = false;
    else this.actionSaveAll = true;
  }

  changeState(fileId, type, $event) {
    if (type === 'valid' && $event)
      this.filesList
        .filter((filterById) => filterById.id === fileId)
        .map((resetError) => (resetError.error = null));
  }

  public fileType(filename) {
    return filename.substring(filename.lastIndexOf('.') + 1, filename.length) || filename;
  }

  public getIcon(type): string {
    const fileType = this.fileTypes[type];
    const icon = fileType
      ? `./assets/icons/files/${fileType}.svg`
      : './assets/icons/files/outros.svg';
    return icon;
  }

  async tryAgain($event, file) {
    if (file) {
      if (this.retry) return;

      this.retry = true;
      this.errorList = this.filesList.filter((filterErrorFeedback) => filterErrorFeedback.error);
      this.filesList = this.filesList.filter((filterErrorFeedback) => !filterErrorFeedback.error);

      await this.reIndex();

      this.table.body = this.filesList;

      this.updateBody = this.filesList.length;
      this.tableRestore = Object.assign(this.table.body);

      setTimeout(() => (this.retry = false), 5000);
      this.startUpload();
    }
  }

  returnFilesList(files, retry = false) {
    const arquivos: any[] = [];
    if (files.length) {
      for (let i = 0; i < files.length; i++) {
        const lastModified = <File>files[i].lastModified;
        const fileName = <File>files[i].name;
        const fileSize = <File>files[i].size;

        const checkError = this.errorList.filter(
          (filteredFile) =>
            filteredFile.lastModified === lastModified &&
            filteredFile.fileName === fileName &&
            filteredFile.size === fileSize
        );

        if ((retry && checkError.length > 0) || !retry) arquivos.push(<File>files[i]);
      }
    }

    return arquivos;
  }

  private showErrorAndReturn(template: any): void {
    this.popupFeedController.autoclose = 6000;
    this.cloudControlEmitter.emit('error');
    this.popupFeedController.show(template);
  }

  startUpload(files?: FileList) {
    let selectedFiles: any[] = [];
    if (files) selectedFiles = this.returnFilesList(files);
    else selectedFiles = this.returnFilesList(this.selectedFiles, true);

    this.selectedFiles = selectedFiles;

    selectedFiles.forEach((file: File) => {
      const maxSize = 1024 * 1024;
      const limitSizeEnabled = this.configuration?.rules?.limitSize;
      const allowedExtensions = this.configuration?.rules?.allowedExtensions;
      const fileExtension = this.fileType(file.name);
      if (limitSizeEnabled && file.size > maxSize) {
        this.showErrorAndReturn(this.templateMaxSizeError);
        return;
      } else if (allowedExtensions && !allowedExtensions.includes(fileExtension)) {
        this.showErrorAndReturn(this.templateInvalidExtensionError);
        return;
      }
      const size = file.size;
      const lastModified = file.lastModified;
      let fileName = file.name;
      const fileType = this.fileType(file.name);
      const nameTreatment = uuidV1() + '.' + fileType;
      const key = this.context + '/' + nameTreatment;
      const fileNameHash = key.split(`/`).slice(-1)[0];

      const checkDuplicidade = this.filesList.filter(
        (file) => file.fileName === fileName && file.fileType === fileType
      );

      if (checkDuplicidade.length > 0) {
        const name = fileName.substring(0, fileName.lastIndexOf('.')) || fileName;

        let maiorNumero = 0;

        const filtered = this.filesList
          .filter((FileTest) => {
            let check = FileTest.fileName.substring(0, FileTest.fileName.lastIndexOf('(') - 1);
            if (!check) check = FileTest.fileName.substring(0, FileTest.fileName.lastIndexOf('.'));
            return check === name;
          })
          .filter((filterType) => filterType.fileType === fileType);

        filtered.forEach((element) => {
          const validacaoNomeArquivo = Number(
            element.fileName.substring(
              element.fileName.lastIndexOf('(') + 1,
              element.fileName.lastIndexOf(')')
            )
          );
          if (validacaoNomeArquivo) {
            if (validacaoNomeArquivo > maiorNumero) maiorNumero = validacaoNomeArquivo;
          }
        });
        maiorNumero++;
        if (maiorNumero > 0) fileName = name + ' (' + maiorNumero + ').' + fileType;
      }

      this.fileUploadService.assignUri({ key: nameTreatment }).subscribe(async (data: any) => {
        const url = data.postUrl.urlUpload;
        const fields = data.postUrl.fields;
        const formData = await this.appendFormData(key, fields, file);

        const fileSave = {
          fileId: uuidV1(),
          context: this.context,
          key: key,
          fileName,
          s3Name: nameTreatment,
          metaData: {
            documentType: null,
            fileType,
            length: size,
          },
        };

        const fileCurrent = {
          context: this.context,
          key,
          id: fileSave.fileId,
          icon: this.getIcon(fileType),
          index: this.filesList.length + 1,
          bucket: fields.bucket,
          etag: null,
          fileName,
          fileNameHash,
          lastModified,
          fileType,
          documentType: null,
          documentTypeName: 'Qual o tipo de documento?',
          download: null,
          size,
          progress: 0,
          uploadDate: dateTrim(),
          user: this.getUserData?.fullname,
          delete: false,
          confirmDelete: false,
          motionCompleteDataSend: false,
          editLabel: false,
          completeLoad: false,
          error: null,
          typeNotSaved: false,
          opened: false,
          validated: null,
          clientView: !this.canViewFiles,
          duplicateFile: !this.canDuplicateFiles,
          justify: null,
          observation: null,
        };

        this.filesList.push(fileCurrent);
        this.table.body = [...this.filesList];

        this.updateBody = this.filesList.length;
        this.tableRestore = Object.assign(this.table.body);

        this.sendService
          .postHttpEvents(url, formData, {}, true)
          .pipe(map((request: any) => request))
          .subscribe(
            (event: HttpEvent<any>) => {
              switch (event.type) {
                case HttpEventType.UploadProgress:
                  fileCurrent.progress = Math.round((event.loaded / event.total!) * 100);
                  break;

                case HttpEventType.Response:
                  this.filesInstance.push({
                    id: fileCurrent.id,
                    value: null,
                    status: null,
                  });

                  this.saveUpload(fileSave, fileCurrent);
                  break;
              }
            },
            (error) => {
              if (
                error.status === 400 ||
                (error.status === 0 && error.name === 'HttpErrorResponse')
              ) {
                this.showOfflineError(fileCurrent);
              }
            }
          );
      });
    });
  }

  async appendFormData(key, fields, file) {
    const formData = new FormData();
    formData.append('acl', 'private');
    formData.append('key', key);
    formData.append('Policy', fields['Policy']);
    formData.append('X-Amz-Credential', fields['X-Amz-Credential']);
    formData.append('X-Amz-Algorithm', fields['X-Amz-Algorithm']);
    formData.append('X-Amz-Date', fields['X-Amz-Date']);
    formData.append('X-Amz-Signature', fields['X-Amz-Signature']);
    if (fields?.['X-Amz-Security-Token'])
      formData.append('X-Amz-Security-Token', fields['X-Amz-Security-Token']);
    formData.append('bucket', fields['bucket']);
    formData.append('file', file);
    return formData;
  }

  async saveUpload(body, fileCurrent) {
    const params = {
      taskId: this.taskId,
      processId: this.processId,
      context: this.context,
    };

    this.cloudControlEmitter.emit('saving');
    this.isSaving = true;
    this.fileUploadService.saveUpload(body, params).subscribe(
      async (success) => {
        this.isSaving = false;
        success.entityKey = this.configuration.entityKey;
        fileCurrent.id = success.id;
        fileCurrent.fileId = success.fileId;
        fileCurrent.editLabel = true;
        await waitingTimer(200);
        fileCurrent.progress = null;
        this.saveValueEmmiter.emit(success);
        this.cloudControlEmitter.emit('saved');
      },
      (error) => {
        this.cloudControlEmitter.emit('error');
      }
    );
  }

  showOfflineError(fileCurrent) {
    fileCurrent.editLabel = true;
    fileCurrent.completeLoad = false;
    fileCurrent.progress = null;
    fileCurrent.motionCompleteDataSend = false;
    fileCurrent.error = ['upload_error'];
    this.error = fileCurrent.error;
  }

  buscaFiltroContains(currentLine, search) {
    if (!currentLine) return;

    const keyMap = Object.getOwnPropertyNames(currentLine);

    return (
      keyMap.find((tag) => {
        if (currentLine[tag] !== undefined) {
          if (String(currentLine[tag]).match(new RegExp(search.toLowerCase(), 'ig'))) return true;
        }
        if ('object' === typeof currentLine[tag]) {
          // tratando nós
          return this.buscaFiltroContains(currentLine[tag], search);
        }
        return false;
      }) !== null
    );
  }

  public orderTable(order) {
    if (!this.initTable) {
      this.initTable = true;
      return;
    }

    let table = Object.assign(this.table.body);

    if (order.searchCriteria) {
      if (this.tableRestore.length > 0)
        table = this.tableRestore.filter((currentLine) =>
          this.buscaFiltroContains(currentLine, order.searchCriteria)
        );
    } else {
      table = this.tableRestore.sort(this.compareValues(order.propertyOrder, order.directionOrder));
      setTimeout(() => this.reIndex(), 50);
    }

    this.table.body = table;
  }

  compareValues(key, order = 'ASC') {
    return (a, b) => {
      if (
        !Object.prototype.hasOwnProperty.call(a, key) ||
        !Object.prototype.hasOwnProperty.call(b, key)
      )
        return 0;
      // if (!a[key] || !b[key])

      const varA = typeof a[key] === 'string' ? a[key].toUpperCase() : a[key];
      const varB = typeof b[key] === 'string' ? b[key].toUpperCase() : b[key];

      let comparison = 0;
      if (varA > varB) {
        comparison = 1;
      } else if (varA < varB) {
        comparison = -1;
      }
      return order === 'DESC' ? comparison * -1 : comparison;
    };
  }

  async reIndex() {
    await this.filesList.forEach((item, index) => (item.index = index + 1));
  }

  public async deleteItem($event, content): Promise<void> {
    if (content.progress !== null) return;

    this.prepareRemove = true;
    this.paginationType = 'none';
    await waitingTimer(20);

    content.remove = !content.remove;
    this.line = { id: content.id, status: content.remove };
  }

  async confirmDelete(content) {
    this.paginationType = 'none';
    await waitingTimer(20);

    this.cloudControlEmitter.emit('saving');

    const paramns = {
      id: content.id,
      taskId: this.taskId,
      processId: this.processId,
      fileId: content.fileId,
    };

    content.isDeleting = true;

    this.fileUploadService.deleteFile(paramns).subscribe(
      async (success) => {
        if (success) success.entityKey = this.configuration.entityKey;

        this.cloudControlEmitter.emit('saved');

        this.lineremove = { id: content.id };
        content.confirmDelete = !content.confirmDelete;

        // await waitingTimer(600);

        const fileId = this.filesList.find((array) => array.confirmDelete === true).id ?? null;

        if (fileId)
          this.filesInstance = this.filesInstance.filter((removeId) => removeId.id !== fileId);

        this.filesList = this.filesList.filter((array) => array.confirmDelete === false);

        await this.reIndex();

        this.table.body = this.table.body.filter((remove) => remove.id !== fileId);

        this.updateBody = this.filesList.length;
        this.tableRestore = Object.assign(this.table.body);

        this.popupFeedController.autoclose = 2000;
        this.popupFeedController.show(this.templateRemove);

        this.checkFilesNotSaved();
        this.saveValueEmmiter.emit(success);

        content.isDeleting = false;
      },
      async (error) => {
        this.popupFeedController.autoclose = 2000;
        this.popupFeedController.show(this.templateRemoveError);

        this.cloudControlEmitter.emit('error');
      }
    );
  }

  openDependencyModule() {
    if (this.configuration.validator) {
      const result = this.filesList.map((a) => a.validator).reduce((a, b) => a && b, true);

      this.setValidatorEmmiter.emit(result);
    }
  }

  getUpload(origin: string, bucket: string, key: string, fileName: string) {
    this.fileUploadService
      .assignUri({ origin, bucket, key, fileName })
      .subscribe(async (data: any) => {
        window.location.href = data.getUrl;

        this.popupFeedController.close();
        this.popupFeedController.autoclose = 2000;
        this.popupFeedController.show(this.templateBaixando);
      });
  }

  async setLaneValue($event) {
    const obj: any = $event;
    this.changeValue(obj.value, obj.lane, obj.entityKey);
  }

  async changeValue($event, file, field) {
    const value = $event;
    let status = 'createCase';

    if (this.taskId !== 'createCase' && this.taskId !== 'base') {
      status = this.taskData[0].status;
    }

    if ((file && status !== 'complete') || this.taskId) {
      if (field === 'validated' && String(value) === 'false') file.opened = true;
      else if (field === 'validated' && String(value) === 'true') {
        file.opened = false;
        file.justify = null;
        file.observation = null;
      }

      file.notExpandable = !file.opened;

      const params = {
        id: file.id,
        fileId: file.fileId,
        taskId: this.taskId,
        processId: this.processId,
        context: this.context,
      };

      const fileChangeSave = {
        [field]: value,
      };

      if (field === 'validated') {
        file['validator'] = value;
      }

      this.filesList
        .filter((filterByFileId) => filterByFileId.id === file.id)
        .map((update) => {
          if (field === 'documentType') {
            file.savingType = true;
            update.documentType = value;
            update.documentTypeName = this.listfiletype.find(
              (filterById) => filterById.value === value
            ).label;
            update.typeNotSaved = false;
          } else update[field] = value;

          if (field === 'validated' && String(value) === 'true') {
            update.justify = null;
            update.observation = null;
            fileChangeSave['observation'] = null;
            fileChangeSave['justify'] = null;
          }
        });

      setTimeout(() => {
        this.cloudControlEmitter.emit('saving');
        this.openDependencyModule();
        this.fileUploadService.updateFile(fileChangeSave, params).subscribe(
          (success) => {
            file.savedOk = true;
            this.cloudControlEmitter.emit('saved');
            if (field === 'documentType') {
              file.savingType = false;
              this.filesInstance
                .filter((filesInstanceId) => filesInstanceId.id === file.id)
                .forEach((change) => {
                  change.value = value;
                  change.status = 'valid';
                });
            }
          },
          (error) => {
            this.cloudControlEmitter.emit('error');
            if (field === 'documentType') {
              file.savingType = false;
              this.filesInstance
                .filter((filesInstanceId) => filesInstanceId.id === file.id)
                .forEach((change) => {
                  change.value = value;
                  change.status = 'error';
                });
            }
          },
          () => {
            this.workflowInitializerService.statusButtonCreate.next(false);
          }
        );
      }, 20);

      this.checkFilesNotSaved();
    }

    this.resetErrorEmmiter.emit();
  }

  async duplicateFileForProcess($event, file) {
    if ($event) {
      this.context = 'files_process';

      const { fileType, fileName, size, key } = file;
      const nameTreatment = uuidV1() + '.' + file.fileType;

      const fileSave = {
        id: uuidV1(),
        fileId: uuidV1(),
        context: this.context,
        key: key,
        fileName,
        s3Name: nameTreatment,
        metaData: {
          documentType: null,
          fileType,
          length: size,
        },
      };

      const keyDraft = file.fileId;
      const valDraft = fileSave.fileId;
      const draftId = {};

      draftId[keyDraft] = valDraft;
      this.filesDuplicate.push(draftId);

      const newFile = this.saveUpload(fileSave, file);

      return newFile;
    } else {
      if (this.filesDuplicate.length !== 0) {
        this.filesDuplicate.forEach((fileId) => {
          Object.values(fileId).forEach((id) => {
            if (id === file.fileId) {
              const body = null;
              const params = {
                fileId: id,
              };

              this.fileUploadService.deleteFileDraftById(body, params).subscribe(async (resp) => {
                return resp;
              });
            }
          });
        });
      }
    }
  }

  salveAll($event) {
    if (!this.actionSaveAll) return;
    this.pullSave = true;
    setTimeout(() => (this.pullSave = false), 10);
    this.cdr.detectChanges();
    this.workflowInitializerService.statusButtonCreate.next(true);
  }

  enableSave($event, file) {
    this.actionSaveAll = true;
    this.filesList
      .filter((filterByFileId) => filterByFileId.id === file.id)
      .map((openSaveStatus) => (openSaveStatus.typeNotSaved = true));

    file.savedOk = false;
  }

  @HostListener('document:click', ['$event'])
  onGlobalClick(event): void {
    if (!this.tableRef) return;

    if (!this.tableRef.nativeElement.contains(event.target) && this.prepareRemove) {
      this.table.body.forEach((element) => {
        if (element.remove) this.deleteItem(event, element);
      });
      this.prepareRemove = false;
    }
  }

  getRemainingFileCount() {
    const externalId = this.dynamicFormService.formControlStructure.formMetadata?.externalId;
    this.fileUploadService.getRemainingFileCount({ externalId }).subscribe((resp) => {
      this.count = resp;
    });
  }
}

interface Rules {
  limitSize: boolean;
  allowedExtensions: Array<string>;
  remainingFileCount: boolean; // regra de contagem de arquivos para o consumidor.gov
}
export interface configurationInterface {
  disable: boolean;
  entityId: string;
  entityKey: string;
  id: string;
  label: string;
  readonly: boolean;
  required: boolean;
  type: string; //"FILE_UPLOAD"
  validator: true;
  optionClientView: any;
  context: any;
  maxFiles: any;
  selectItens: boolean;
  rules: Rules;
  entityUrl?: string;
  optionDuplicateFile: any;
}
